module.exports = __webpack_public_path__ + "static/media/Zvook_Client_Page_(optimized).2db20021.png";